const BREAKPOINT = 767.98

export const isMobile = () => window.innerWidth <= BREAKPOINT
